module.exports = __webpack_public_path__ + "img/itx-file-type-7z.ac333e56.svg";